export type OnBeforeUnload = (callback: (event: Event) => void) => {
  remove: () => void;
};
